import Plyr from 'plyr';
import gsap from 'gsap';
import { ev, isMobile } from '../../utils';
import { Wheel, onSwipe } from '../../utils/scroll';
import $ from 'jquery';
const pathDraggableButton = require('../../utils/path-draggable-button');
import HeroOutAnimation from './HeroOutAnimation';

import { initAisleLotties, lottieDta, lottieAisle, initBusinessSeat } from '../lottie';
import initAisleVideo from '../aisleVideo';

import { isTouch } from '../../utils';

import { addHeroContentAnimation } from '../heroContentAnimation';

import LocomotiveScroll from 'locomotive-scroll';

import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { business } from '../video/data';

window.ScrollTrigger = ScrollTrigger;

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

// pathDraggableButton();

class Aisle {
	constructor({ holder }) {
		this.holder = holder;
		this.wrapSelector = '[data-aisle-wrap]';
		this.backBtn = this.holder.querySelector('.back-btn');
		this.$hero = $('[data-aisle-hero]');
		this.$startButton = $('[data-aisle-start]');
		this.currentType = '';

		this.activeSegmentIndex = 0;

		this.animationInterval = null;

		this.seatsVisible = false;

		this.seats = {
			business: {
				init: false,
				scroll: null,
			},
			premium: {
				init: false,
				scroll: null,
			},
		};

		this.tl = gsap.timeline();

		this.heroOutAnimation = new HeroOutAnimation({
			onComplete: () => {
				this.seatsVisible = true;

				if (!this.seats[this.currentType].init) {
					this.initScroll(this.currentType);
				} else {
					window.dispatchEvent(new Event('resize'));
				}
			},
		});
	}

	getCurrentElements() {
		const wrapper = document.querySelector(`[data-aisle-${this.currentType}]`);
		const swiperContainer = wrapper.querySelector('.mySwiper');

		return {
			wrapper,
			swiperContainer,
		};
	}

	resetAnimation() {
		this.heroOutAnimation.reset();
		//console.log('resetAnimation');
		$('body').removeClass('is-seats-animation is-seats-active');
	}

	addHeroAnimation() {
		if (this.seats[this.currentType].scroll) {
			//console.log('try his.seats[this.currentType].scroll.scrollTo', this.currentType);
			setTimeout(() => {
				//console.log('setTimeout try his.seats[this.currentType].scroll.scrollTo', this.currentType);

				this.seats[this.currentType].scroll.setScroll(0);
				this.seats[this.currentType].scroll.update();
			}, 300);
		}

		if (!this.tl.getChildren().length) {
			this.tl.to(
				$('body'),
				{
					duration: 2,
					ease: 'power2.out',
					onComplete: () => {
						$('body').addClass('is-seats-hidden-img');
					},
				},
				1,
			);
			this.tl.to(
				'foo',
				{
					duration: 1,
					onComplete: () => {
						console.log('check play lottie');
						this.playLottie();
					},
				},
				1,
			);

			addHeroContentAnimation(this.tl, this.wrapSelector);
		}

		!this.seats[this.currentType].init &&
			this.tl.fromTo(
				document.querySelectorAll(this.wrapSelector + ' [data-i-hero-visuals]'),
				{
					y: 100,
					opacity: 0,
				},
				{
					y: 0,

					duration: 1,
					opacity: 1,
					ease: 'power2.out',
				},
				1,
			);

		console.log(this.tl.getChildren());

		if (this.tl) {
			this.tl.restart();
		}

		this.initLottie();
	}

	initLottie(timeout = 300) {
		setTimeout(() => {
			if (!this.lottieAnimations) {
				this.lottieAnimations = lottieAisle();
			}
		}, timeout);
	}

	playLottie(timeout = 300) {
		// setTimeout(() => {
		// if (!this.lottieAnimations) {
		// 	this.lottieAnimations = lottieAisle();
		// }
		this.lottieAnimations.animationOneAisle.play();
		this.lottieAnimations.animationTwoAisle.play();
		// }, timeout);
	}

	restartLottie() {
		if (this.lottieAnimations) {
			this.lottieAnimations.animationOneAisle.goToAndStop(0);
			this.lottieAnimations.animationTwoAisle.goToAndStop(0);
		}
	}

	init() {
		const grif = this;

		this.isStarted = false;

		const handleStartAction = () => {
			if (this.isStarted) return;
			this.isStarted = true;
			this.$startButton.eq(0).trigger('click');
		};

		const options = {
			onDown: handleStartAction,
			onLeft: handleStartAction,
		};

		if (!isTouch()) {
			const handleWheel = new Wheel(this.$hero.get(0), options);
		} else {
			const handleSwipe = new onSwipe(this.$hero.get(0), options);
		}

		this.$startButton.on('click', () => {
			//console.log('[data-aisle-start]');

			this.backBtn.classList.add('is-active');

			this.heroOutAnimation.play();
		});

		this.backBtn.addEventListener('click', () => {
			this.isStarted = false;

			ev('hideAisle');
			ev('showVideo', { paused: !window.isVideoOverlayShown });
			ev('backToVideo');

			grif.resetAnimation();

			this.restartLottie();

			$('body').removeClass('is-seats-hidden-img');
		});

		document.addEventListener('showAisle', (e) => {

			//console.log('showAisle');
			ev('hideVideo', {});

			this.currentType = e.detail.type;

			window.currentType = e.detail.type;

			this.updateHero(this.currentType);

			$(this.wrapSelector).removeClass('is-hidden-component');

			this.loadSeats(e.detail.type);

			setTimeout(() => {
				this.addHeroAnimation();
			}, 0);
		});

		document.addEventListener('hideAisle', (e) => {
			//console.log('hideAisle');
			this.hideSeats(this.currentType);
			$(this.wrapSelector).addClass('is-hidden-component');
		});
	}

	updateHero(type) {
		this.$hero.removeClass('bg-aisle-business bg-aisle-premium');
		this.$hero.addClass('bg-aisle-' + type);

		this.$hero.toggleClass('-busines', type == 'business');
	}

	loadSeats(type) {
		const container = document.querySelector(this.wrapSelector);
		const template = document.querySelector(`[data-aisle-template-${type}]`);

		if (template) {
			container.appendChild(template.content.cloneNode(true));

			template.parentNode.removeChild(template);
			setTimeout(() => {
				this.initSeats(type);
				this.showSeats(type);
				this.positionScrollContainer(type);
			}, 1000);
		} else {
			console.log(type + ' aisle is already loaded.');
			this.showSeats(type);
			this.positionScrollContainer(type);
		}
	}

	showSeats(type) {
		const articleWrap = document.querySelector(`[data-aisle-${type}]`);

		$(articleWrap).removeClass('is-hidden-component');
	}

	hideSeats(type) {
		const articleWrap = document.querySelector(`[data-aisle-${type}]`);

		$(articleWrap).addClass('is-hidden-component');

		this.reset();
	}

	reset() {
		this.seatsVisible = false;
		setTimeout(() => {
			this.$hero.removeClass('is-hidden-component');
			this.backBtn.classList.remove('is-active');
		}, 500);
	}

	initSeats() {
		initBusinessSeat();

		initAisleLotties();

		this.initSeatsVideo();

		this.initSeatInteraction();

		//console.log('initSeats');
	}

	initSeatsVideo() {
		const self = this;
		const { wrapper, swiperContainer } = this.getCurrentElements();
		const swiperVideoAnimationSeat = swiperContainer.querySelectorAll('[data-video-slider-animation]');

		initAisleVideo();

		swiperVideoAnimationSeat.forEach((btn) => {
			btn.addEventListener('click', function () {
				const secondContainer = btn.closest('[data-video-st="secondContainer"]');
				btn.classList.toggle('is-active');
				if (btn.classList.contains('is-active')) {
					self.animationInterval = setInterval(() => {
						secondContainer.classList.toggle('is-animate');
					}, 2000);
				} else {
					clearInterval(self.animationInterval);
				}
			});
		});
	}

	initSeatInteraction() {
		const { wrapper, swiperContainer } = this.getCurrentElements();

		function toggleContent($container, isClick) {
			if (isClick) $container.toggleClass('is-toggled');

			if (!isClick) $container.addClass('is-toggled');
		}

		$(swiperContainer.querySelectorAll('[data-path-draggable-container]')).each(function () {
			const $container = $(this);
			$container.find('[data-path-draggable]').each(function () {
				const pathDraggableSettings = $(this).data('path-draggable').split(',');
				const negative = pathDraggableSettings[0] === 'false' ? false : true;
				const direction = pathDraggableSettings[1].trim();

				$(this)
					.pathDraggableButton({
						pathSelector: 'path',
						negative: negative,
						direction: direction,
					})
					.on('change', function (e, button, value) {
						$(this).toggleClass('is-started', value > 0.05);
						document.body.dispatchEvent(
							new CustomEvent('data-analytics', { detail: $(this).attr('data-analytics') }),
						);

					})
					.on('finish', function (e) {
						toggleContent($container);
					});
			});

			$container.find('.btn-seat').on('click', function () {
				// console.log('.btn-seat');
				toggleContent($container, true);
			});
		});
	}

	positionScrollContainer(type) {
		console.log(type);
		const { wrapper, swiperContainer } = this.getCurrentElements();

		//console.log('swiperContainer', swiperContainer);

		const slides = swiperContainer.querySelectorAll('.swiper-slide');

		const swiperWrapper = wrapper.querySelector('.swiper-wrapper');
		// slides[0].classList.add('swiper-slide-prev');

		$(slides).removeClass('swiper-slide-active swiper-slide-prev swiper-slide-next');
		slides[1].classList.add('swiper-slide-active');
		// slides[2].classList.add('swiper-slide-next');

		function getPositionRelativeToWrapper() {
			let wrapperRect = swiperWrapper.getBoundingClientRect();
			let childRect = slides[1].getBoundingClientRect();

			// console.log(wrapperRect);
			// console.log(childRect);

			let relativePos = {
				top: childRect.top - wrapperRect.top,
				left: childRect.left - wrapperRect.left,
				bottom: childRect.bottom - wrapperRect.bottom,
				right: childRect.right - wrapperRect.right,
			};

			return relativePos;
		}

		var position = getPositionRelativeToWrapper();
		// console.log(position);
		// console.log(slides[1].getBoundingClientRect());

		function onResize() {
			var position = getPositionRelativeToWrapper();
			// console.log(position); // Update position on resize

			const seatsSpace = +swiperContainer.dataset.seatsSpace;

			const offset = window.innerWidth / 2 - (slides[0].offsetWidth + slides[1].offsetWidth / 2) - seatsSpace;
			console.log(offset, 'offset');

			$(slides[0]).css({ 'margin-left': offset + 'px' });
			$(slides[slides.length - 1]).css({ 'margin-right': offset + 'px' });
			// lScroll.update();
		}

		onResize();

		if (this.seats[type].init) return;

		// Add resize event listener
		window.addEventListener('resize', onResize);

		// window.dispatchEvent(new Event('resize'));
	}

	onItemChange() {}

	setScrollerProxy(type) {
		console.log('setScrollerProxy aisle');
		const { wrapper, swiperContainer } = this.getCurrentElements();
		const self = this;

		console.log(self.seats[type].scroll);

		ScrollTrigger.defaults({
			scroller: swiperContainer,
		});

		ScrollTrigger.scrollerProxy(swiperContainer, {
			scrollTop(value) {
				//console.log(lScroll.scroll.instance.scroll.y);

				return arguments.length
					? self.seats[type].scroll.scrollTo(value, 0, 0)
					: self.seats[type].scroll.scroll.instance.scroll.y;
			}, // we do89n't have to define a scrollLeft because we're only scrolling vertically.
			scrollLeft(value) {
				//console.log(lScroll.scroll.instance.scroll.x);
				return arguments.length
					? self.seats[type].scroll.scrollTo(value, 0, 0)
					: self.seats[type].scroll.scroll.instance.scroll.x;
			}, // we do89n't have to define a scrollLeft because we're only scrolling vertically.
			getBoundingClientRect() {
				return {
					top: 0,
					left: 0,
					width: window.innerWidth,
					height: window.innerHeight,
				};
			},

			pinType: 'transform',
		});
	}

	initScroll(type) {
		this.seats[type].init = true;
		const { wrapper, swiperContainer } = this.getCurrentElements();

		const slides = swiperContainer.querySelectorAll('.swiper-slide');

		const scroller = swiperContainer;

		console.log('initScroll(type)');

		var article = 'shanti';
		var premArticle = document.querySelector('.article-content[data-article-premium]');
		if (premArticle && premArticle.style.display != 'none') {
			article = 'etienne';
		}

		document.body.dispatchEvent(
			new CustomEvent('data-analytics', { detail: '2024-sia-aisle-' + article + '-screeninteract' }),
		);

		const scroll = new LocomotiveScroll({
			el: scroller,
			smooth: true,
			// offset: [0, position.left],
			gestureDirection: 'both',
			direction: 'horizontal',
			// scrollFromAnywhere: true,
			scrollbarContainer: wrapper.querySelector('.swiper-container-wrapp'),
			multiplier: 0.3,
			lerp: isTouch() ? 0.1 : 0.1,
			touchMultiplier: 5,
			firefoxMultiplier: 100,
			tablet: {
				direction: 'horizontal',
				smooth: true,
				gestureDirection: 'both',
			},
			smartphone: {
				direction: 'horizontal',
				smooth: true,
				gestureDirection: 'both',
			},
		});

		this.seats[type].scroll = scroll;

		window.seats = this.seats;

		// window.swiperScroll = lScroll;

		scroll.on('scroll', ({ limit, scroll }) => {
			const progress = scroll.y / limit.y;

			if (scroll.y > 0) {
				// document.body.classList.add('fixed-locomotive');
			} else {
				// document.body.classList.remove('fixed-locomotive');
			}

			ScrollTrigger.update();
		});

		this.setScrollerProxy(type);
		const self = this;

		new ResizeObserver(() => {
			ScrollTrigger.update();
			ScrollTrigger.refresh();
		}).observe(scroller);

		const animationSlide = 2;

		const seatsSpace = +swiperContainer.dataset.seatsSpace;

		console.log('seatsSpace', seatsSpace);

		ScrollTrigger.create({
			start: `${scroll.scroll.instance.limit.x - 100} left`,
			end: 'right right',
			onEnter: () => {
				if (this.seatsVisible && !isMobile) this.backBtn.classList.remove('is-active');
			},
			onLeaveBack: () => {
				if (this.seatsVisible && !isMobile) this.backBtn.classList.add('is-active');
			},
			horizontal: true,
		});

		slides.forEach((container, i) => {
			ScrollTrigger.create({
				trigger: container,
				horizontal: true,
				start: `left-=${seatsSpace / 2} center`,
				end: `right+=${seatsSpace / 2} center`,
				// markers: true,
				// scroller: '[data-scroll-container]',
				onToggle: (self) => {
					// console.log('onEnter');
					// lottieInitNoLoopStart.play();
					if (!this.seatsVisible) return;

					$(slides[i - 1]).toggleClass('swiper-slide-prev');
					$(slides[i + 1]).toggleClass('swiper-slide-next');
					$(container).toggleClass('swiper-slide-active', self.isActive);

					if (self.isActive) {
						swiperContainer.querySelectorAll('[data-video-st="container"].is-play').forEach((container) => {
							const video = container.querySelector('video');
							const videoWrapper = container.closest('[data-video-st="secondContainer"]');
							if (video) {
								video.pause();
								video.muted = true;
								container.classList.remove('is-play');
							}
							if (videoWrapper) {
								if (videoWrapper.classList.contains('is-play')) {
									videoWrapper.classList.remove('is-play');
									const btnInner = videoWrapper.querySelector(
										'[data-video-slider-animation].is-active',
									);
									if (btnInner) {
										btnInner.classList.remove('is-active');
									}
									clearInterval(self.animationInterval);
									// secondContainer.classList.remove('is-animate');
								}
							}
						});
						// console.log('iiiiiiii', i);
						if (i === animationSlide) {
							restartLottieAnimation();
						} else {
							destroyLottieAnimation();
						}
					}
				},
				onEnter: () => {},
			});
		});

		function restartLottieAnimation() {
			const lottieElements = document.querySelectorAll('[data-lottie-restart-dta-one]');
			lottieElements.forEach((el) => {
				const animation = lottieDta();
				if (animation) {
					animation.animationDta.play();
				}
			});
		}
		function destroyLottieAnimation() {
			const lottieElements = document.querySelectorAll('[data-lottie-restart-dta-one]');
			lottieElements.forEach((el) => {
				const animation = lottieDta();
				if (animation) {
					animation.animationDta.destroy();
				}
			});
		}
	}
}

export default function initAisle(gsap, ScrollTrigger) {
	document.querySelectorAll('[data-aisle-wrap]').forEach((holder) => {
		const instance = new Aisle({ holder, gsap, ScrollTrigger });

		instance.init();
	});
}
